import { useState, useEffect, useMemo } from 'react';
import MapView from './Map//MapView';
import ContentView from './ContentView/ContentView';
import Overlay from './common/Overlay';
import './App.css';
import ArrowLeft from './common/ArrowLeft';
import ArrowRight from './common/ArrowRight';

function App() {

  const [isMarkerSelected, setIsMarkerSelected] = useState(false);
  const [appData, setAppData] = useState(null);
  const [content, setContent] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isContentCollapsed, setIsContentCollapsed] = useState(false);
  const [prevCollapseState, setPrevCollapseState] = useState(false);

  // Fetch the placeholder data for the ContentView
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/app-data?populate[placeholderImage][populate]=image&populate[logos][populate]=*`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Fehler beim Abrufen der App-Daten');
        }
        return response.json();
      })
      .then((res) => {
        setAppData(res.data);
      })
      .catch((error) => {
        console.error('Fehler:', error);
      });
  }, []);

  // Fallback data in case backend connection is lost
  const placeholderData = useMemo(() => ({
    title: appData?.placeholderTitle || "Nachhaltigkeit an der UR",
    description: appData?.placeholderDescription || "Auf dieser Karte können Sie alle Nachhaltigkeitsprojekte der Universität Regensburg sehen. Klicken Sie auf einen Marker, um hier Details zum jeweiligen Projekt zu erhalten.",
    img: appData?.placeholderImage ? appData.placeholderImage : null,
    logos: appData?.logos ? appData.logos : null
  }), [appData]);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 768);
    }
    window.addEventListener('resize', handleResize);

    // Cleanup: Remove the event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Reset collapse state when a marker is selected. Set the state to the previous one
  // when marker content is closed
  useEffect(() => {
    if (isMarkerSelected) {
      setPrevCollapseState(isContentCollapsed);
      setIsContentCollapsed(false);
    } else {
      setIsContentCollapsed(prevCollapseState);
    }
  // eslint-disable-next-line
  }, [isMarkerSelected]);

  return (
    <div className="App">
      <div className="Header">
        <h1>{appData?.appTitle || "Nachhaltiger Campus"}</h1>
      </div>
      <div className="ContentContainer">

        {/* The Leaflet map */}
        <MapView
          setIsMarkerSelected={setIsMarkerSelected}
          content={content}
          setContent={setContent}
          isContentCollapsed={isContentCollapsed}
        />

        {!isMobile && (
          <div className={`ContentViewWrapper ${isContentCollapsed ? 'collapsed' : ''}`}>
            {!isMarkerSelected && (
              <button 
                className="CollapseButton"
                onClick={() => setIsContentCollapsed(!isContentCollapsed)}
                title={isContentCollapsed ? "Panel ausklappen" : "Panel einklappen"}
              >
                {isContentCollapsed ? <ArrowLeft /> : <ArrowRight />}
              </button>
            )}

            {/* ContentView for displaying information */}
            <ContentView
              showContent={isMarkerSelected}
              setIsMarkerSelected={setIsMarkerSelected}
              content={content}
              placeholderData={placeholderData}
              isCollapsed={isContentCollapsed}
            />
          </div>
        )}
        
        {/* On mobile, there is no default ContentView */}
        {isMobile && isMarkerSelected && (
          <Overlay
            onClose={() => setIsMarkerSelected(false)}
            darkBackground={true}
            style={{
              top: "0",
              left: "0",
              width: "100vw",
              height: "100vh"
            }}
          >
            <div className="MobilePopupContent" onClick={(e) => e.stopPropagation()}>
              <ContentView
                showContent={isMarkerSelected}
                setIsMarkerSelected={setIsMarkerSelected}
                content={content}
                placeholderData={placeholderData}
                isCollapsed={false}
              />
            </div>
          </Overlay>
        )}
      </div>
    </div>
  );
}

export default App;